import React, { useState, useEffect } from "react";
import Button from "../../shared/Button";
import SVG from "react-inlinesvg";
import DatePicker from "react-date-picker";
import PropTypes from "prop-types";
import { useGeolocation } from "../../../hooks/useGeolocation/useGeolocation";
import api from "../../../lib/PinchMeAPI";
import classNames from "classnames";

//images
import letter from "../../../../../assets/images/redesign/signup-react/email.svg";
import eyeOpen from "../../../../../assets/images/redesign/signup-react/View.svg";
import eyeClosed from "../../../../../assets/images/redesign/signup-react/Hide.svg";
import calendar from "../../../../../assets/images/redesign/signup-react/Calendar.svg";
import pin from "../../../../../assets/images/redesign/signup-react/pin.svg";

function SignupForm({ login, setLogin, isSecondVersion }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [date, setDate] = useState(null);
  const [gender, setGender] = useState("");
  const [zip, setZip] = useState("");
  const [showPassword, setShowPassword] = useState("");

  const [nameErrors, setNameErrors] = useState(null);
  const [emailErrors, setEmailErrors] = useState(null);
  const [passwordErrors, setPasswordErrors] = useState(null);
  const [birthdateErrors, setBirthdateErrors] = useState(null);
  const [genderErrors, setGenderErrors] = useState(null);
  const [zipCodeErrors, setZipCodeErrors] = useState(null);
  const [loginErrors, setLoginErrors] = useState(null);

  const [birthDay, setBirthDay] = useState(null);
  const [birthMonth, setBirthMonth] = useState(null);
  const [birthYear, setBirthYear] = useState(null);

  const { getLocation, coords } = useGeolocation();

  useEffect(() => {
    setPassword("");
    setEmail("");
  }, [login]);

  useEffect(() => {
    updateBirthDate();
  }, [birthDay, birthMonth, birthYear]);

  function updateBirthDate() {
    if (birthMonth == null || birthDay == null || birthYear == null)
      return null;

    if (birthMonth < 1 || birthMonth > 12) {
      setDate(null);
      setBirthdateErrors("Invalid month");
      return null;
    }

    if (
      birthYear > new Date().getFullYear() - 16 ||
      birthYear < 1900
    ) {
      setDate(null);
      setBirthdateErrors("Invalid year");
      return null;
    }

    if (birthDay < 1 || birthDay > 31) {
      setDate(null);
      setBirthdateErrors("Invalid day");
      return null;
    }
    
    // You'd think a switch statement here would be better.
    // Except that for some reason it just fails and ends up in default every time.
    if (birthMonth == 2) {
      if (birthDay > 30) {
        setDate(null);
        setBirthdateErrors("Invalid day");
        return null;
      }
      else if (birthYear % 4 == 0) {
        if (birthDay > 29) {
          setDate(null);
          setBirthdateErrors("Invalid day");
          return null;
        }
      } else {
        if (birthDay > 28) {
          setDate(null);
          setBirthdateErrors("Invalid day");
          return null;
        }
      }
    }
    else if (birthMonth == 4 ||
             birthMonth == 6 ||
             birthMonth == 9 ||
             birthMonth == 11){
      if (birthDay > 30) {
        setDate(null);
        setBirthdateErrors("Invalid day");
        return null;
      }
    }

    var birthdate = new Date(birthYear, birthMonth - 1, birthDay);
    setDate(birthdate);
    setBirthdateErrors("");
  }

  let handleChange = ev => {
    let { name, value } = ev.currentTarget;
    switch (name) {
      case "name":
        setName(value);
        nameCheck(ev);
        setNameErrors(null);
        break;
      case "email":
        setEmail(value);
        emailCheck(ev);
        setEmailErrors(null);
        break;
      case "password":
        setPassword(value);
        passwordCheck(ev);
        setPasswordErrors(null);
        break;
      case "zipcode":
        setZip(value);
        zipCodeCheck(ev);
        setZipCodeErrors(null);
        break;
      case "gender":
        setGender(value);
        setGenderErrors(null);
        break;
      case "birthDay":
        maxLengthCheck(ev);
        setBirthDay(ev.currentTarget.value);
        if(ev.currentTarget.value.length > 1)
          ev.currentTarget.nextElementSibling.focus();
        break;
      case "birthMonth":
        maxLengthCheck(ev);
        setBirthMonth(ev.currentTarget.value);
        if(ev.currentTarget.value.length > 1)
          ev.currentTarget.nextElementSibling.focus();
        break;
      case "birthYear":
        maxLengthCheck(ev);
        setBirthYear(ev.currentTarget.value);
        break;
    }
  };
  let nameCheck = object => {
    // Reg exp for the name.
    // The rule is that At least one letter followed by a space then followed by at least one letter.
    // Punctuation is allowed for names like Conan O'Brien and Daniel Day-Lewis

    var name_regex = /([A-Za-z]+['-]*)+( )([A-Za-z]+[' -]*)+$/
    if (!object.target.value.match(name_regex)){
      object.target.parentNode.classList.add("pw-login-maybe-error");
    }
    else{
      object.target.parentNode.classList.remove("pw-login-maybe-error");
    }
  }

  let emailCheck = object => {
    var email_regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/
    if (!object.target.value.match(email_regex)){
      object.target.parentNode.classList.add("pw-login-maybe-error");
    }
    else{
      object.target.parentNode.classList.remove("pw-login-maybe-error");
    }
  }

  let passwordCheck = object => {
    var element = document.getElementsByClassName("pw-login-container--pass-reminder")[0]
    if (object.target.value.length < 6){
      object.target.parentNode.classList.add("pw-login-maybe-error");
      element.classList.add("pw-login-maybe-error");
      element.classList.remove("pw-login-no-error");
    }
    else{
      object.target.parentNode.classList.remove("pw-login-maybe-error");
      element.classList.remove("pw-login-maybe-error");
      element.classList.add("pw-login-no-error");
    }
  }

  let zipCodeCheck = object => {
    if (object.target.value.length < 5){
      object.target.parentNode.classList.add("pw-login-maybe-error")
    }
    else if (object.target.value.length > 5){
      object.target.parentNode.classList.add("pw-login-error")
    }
    else {
      object.target.parentNode.classList.remove("pw-login-maybe-error")
      object.target.parentNode.classList.remove("pw-login-error")
    }
  }

  let maxLengthCheck = object => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  let submitSignup = async () => {
    let fullName = name.split(" ");
    let firstName = fullName.shift();
    let lastName = fullName.join(" ");

    try {
      let response = await api.submitSignup(
        firstName,
        lastName,
        email,
        password,
        date,
        zip,
        gender
      );

      if (response.status > 199 && response.status < 300) {
        window.location.replace(response.redirect_to);
      } else {
        handleErrors(response.data.errors);
      }
    } catch (error) {
      console.error(error);
      console.error(error.response.data.errors);
    }
  };

  let submitLogin = async () => {
    try {
      let response = await api.submitLogin(email, password);
      if (response.status > 199 && response.status < 300) {
        window.location.replace(response.redirect_to);
      } else {
        if (response.data) {
          if (response.data.error)
            handleError(response.data.error);
          else
            handleErrors(response.data.errors);
        } else {
          console.error(response.status);
        }
      }
    } catch (error) {
      console.error(error);
      console.error(error.response.data.errors);
    }
  };

  let handleFormSubmit = async ev => {
    ev.preventDefault();
    if (login) {
      await submitLogin();
    } else {
      await submitSignup();
    }
  };

  let handleError = error => {
    setLoginErrors(error);
  }

  let handleErrors = errors => {
    if(errors["first_name"])
      setNameErrors(errors["first_name"].join(" "))
    else if(errors["last_name"])
      setNameErrors(errors["last_name"].join(" "))
    else
      setNameErrors(null);
    errors["email"]
      ? setEmailErrors(errors["email"].join(" "))
      : setEmailErrors(null);
    errors["password"] ? setPasswordErrors(errors["password"].join(" ")) : null;
    errors["user_profile.age"]
      ? setBirthdateErrors(errors["user_profile.age"].join(" "))
      : null;
    errors["user_profile.gender"]
      ? setGenderErrors(errors["user_profile.gender"].join(" "))
      : null;
    errors["user_profile.zip_code"][0]
      ? setZipCodeErrors(errors["user_profile.zip_code"][0])
      : null;
  };

  // The following functions are for dropdown Calendar ranges
  //
  // function monthRange() {
  //   const months = Array.from({ length: 12 }, (x, i) => i + 1);
  //   return (
  //     <select
  //       name="birthMonth"
  //       onChange={handleChange}
  //       defaultValue={"DEFAULT"}
  //     >
  //       <option value={"DEFAULT"} disabled={true}>
  //         MM
  //       </option>
  //       {months.map(month => {
  //         return (
  //           <option key={month} value={month}>
  //             {month}
  //           </option>
  //         );
  //       })}
  //     </select>
  //   );
  // }

  // function dayRange() {
  //   var maxDay;
  //   switch (birthMonth) {
  //     case "2":
  //       if (birthYear % 4 == 0) {
  //         maxDay = 29;
  //         break;
  //       } else {
  //         maxDay = 28;
  //         break;
  //       }
  //     case "4":
  //     case "6":
  //     case "9":
  //     case "11":
  //       maxDay = 30;
  //       break;
  //     case "1":
  //     case "3":
  //     case "5":
  //     case "7":
  //     case "8":
  //     case "10":
  //     case "12":
  //     default:
  //       maxDay = 31;
  //       break;
  //   }
  //   const days = Array.from({ length: maxDay }, (x, i) => i + 1);
  //   return (
  //     <select name="birthDay" onChange={handleChange} defaultValue={"DEFAULT"}>
  //       <option value={"DEFAULT"} disabled={true}>
  //         DD
  //       </option>
  //       {days.map(day => {
  //         return (
  //           <option key={day} value={day}>
  //             {day}
  //           </option>
  //         );
  //       })}
  //     </select>
  //   );
  // }

  // function yearRange() {
  //   var current_year = new Date().getFullYear();
  //   const years = Array.from(
  //     { length: current_year - 1899 - 16 },
  //     (x, i) => current_year - i - 16
  //   );
  //   return (
  //     <select name="birthYear" onChange={handleChange} defaultValue={"DEFAULT"}>
  //       <option value={"DEFAULT"} disabled={true}>
  //         YYYY
  //       </option>
  //       {years.map(year => {
  //         return (
  //           <option key={year} value={year}>
  //             {year}
  //           </option>
  //         );
  //       })}
  //     </select>
  //   );
  // }

  return (
    <div>
      <form>
        {login ? null : (
          <div className="pw-login-container--field pw-mb-3">
            <div className="pw-login-container--field-item d-flex">
              <input
                value={name}
                name={"name"}
                id={"name"}
                onChange={handleChange}
                className="pw-login-container--input"
                type="text"
                required
              />
              <label className="pw-login-container--label" htmlFor={"name"}>
                FULL NAME
              </label>
            </div>
            <small className="pw-login-error">{nameErrors}</small>
          </div>
        )}

        <div className="pw-login-container--field pw-mb-3">
          <div className="pw-login-container--field-item d-flex">
            <input
              value={email}
              name={"email"}
              id={"email"}
              onChange={handleChange}
              className="pw-login-container--input"
              type="text"
              required
            />
            <label className="pw-login-container--label" htmlFor={"email"}>
              EMAIL
            </label>
            <div className="pw-login-container--input-items">
              <SVG
                width={25}
                height={25}
                className="pw-ml-2 pw-icon-active"
                fill="red"
                src={letter}
              />
            </div>
          </div>
          <small className="pw-login-error">{emailErrors}</small>
        </div>

        <div className="pw-login-container--field">
          <div className="pw-login-container--field-item d-flex">
            <input
              value={password}
              name={"password"}
              id={"password"}
              onChange={handleChange}
              className="pw-login-container--input"
              type={showPassword ? "text" : "password"}
              required
            />
            <label
              className="pw-login-container--label or"
              htmlFor={"password"}
            >
              PASSWORD
            </label>
            <div
              className="pw-login-container--input-items"
              onClick={() => setShowPassword(s => !s)}
            >
              <span
                className={classNames({
                  "pw-svg-password-active pw-opacity-ha": showPassword,
                  "pw-opacity-hafl": !showPassword
                })}
              >
                {showPassword ? "Hide" : "Show"}
              </span>
              <SVG
                width={25}
                height={25}
                className={classNames({
                  "pw-svg-password-active pw-opacity-ha": showPassword,
                  "pw-opacity-hafl": !showPassword
                })}
                fill="red"
                src={showPassword ? eyeClosed : eyeOpen}
              />
            </div>
          </div>
          <p className="pw-login-container--pass-reminder">
            Password must be at least 6 characters
          </p>

          {login ? (
            <p className="pw-login-container--terms pw-text-right">
              <a href="password/new">
                <span>Forgot your password?</span>
              </a>
            </p>
          ) : null}
        </div>

        {login ? null : (
          <>
            <div className="pw-login-container--birth-container">
              <div className="pw-login-container--field pw-login-birth pw-mb-3 pw-mr-3">
                <div className="pw-login-container--field-item d-flex d-start">
                  <input
                    type="number"
                    name="birthMonth"
                    onInput={handleChange}
                    placeholder="MM"
                    maxLength="2"
                    min="1"
                    max="12"
                    style={{ width: "68px" }}
                  />

                  <input
                    type="number"
                    name="birthDay"
                    onInput={handleChange}
                    placeholder="DD"
                    maxLength="2"
                    min="1"
                    max="31"
                    style={{ width: "60px" }}
                  />

                  <input
                    type="number"
                    name="birthYear"
                    onInput={handleChange}
                    placeholder="YYYY"
                    maxLength="4"
                    min="1900"
                    max={new Date().getFullYear() - 16}
                  />

                  {/* {monthRange()}
                  {dayRange()}
                  {yearRange()} */}
                  <label
                    className="pw-login-container--label force"
                    htmlFor={"birthdate"}
                  >
                    DATE OF BIRTH
                  </label>
                </div>
                <small className="pw-login-error">{birthdateErrors}</small>
              </div>

              <div className="pw-login-container--field pw-login-zip pw-mb-3">
                <div className="pw-login-container--field-item d-flex">
                  <input
                    type="text"
                    name={"zipcode"}
                    id={"zipcode"}
                    onChange={handleChange}
                    className="pw-login-container--input"
                    value={zip}
                    required
                  />
                  <label
                    className="pw-login-container--label"
                    htmlFor={"zipcode"}
                  >
                    ZIPCODE
                  </label>
                  <div className="pw-login-container--input-items-calendar pw-login-items-pin">
                    <SVG
                      width={21}
                      height={21}
                      className="pw-ml-2 pw-icon-active"
                      fill="red"
                      src={pin}
                    />
                  </div>
                </div>
                <small className="pw-login-error">{zipCodeErrors}</small>
              </div>
            </div>
            <div className="pw-login-container--radio-field pw-mb-3">
              <div className>
                <div className="gender-label">Gender</div>
                <div className="pw-login-container--button-group d-flex">
                  <div className={"pw-login-container--button"}>
                    <input
                      value={0}
                      name={"gender"}
                      id={"female"}
                      onChange={handleChange}
                      placeholder=""
                      className="pw-login-container--button-radio"
                      type="radio"
                      checked={gender === "0"}
                    />
                    <label
                      htmlFor={"female"}
                      className="pw-login-container--button-label"
                    >
                      Female
                    </label>
                  </div>
                  <div className={"pw-login-container--button"}>
                    <input
                      value={1}
                      name={"gender"}
                      id={"male"}
                      onChange={handleChange}
                      placeholder=""
                      className="pw-login-container--button-radio"
                      type="radio"
                      checked={gender === "1"}
                    />
                    <label
                      htmlFor={"male"}
                      className="pw-login-container--button-label"
                    >
                      Male
                    </label>
                  </div>
                </div>
                <label
                  className="pw-login-container--label force sr-only hidden"
                  htmlFor={"gender"}
                >
                  GENDER
                </label>
              </div>
              <small className="pw-login-error">{genderErrors}</small>
            </div>
          </>
        )}

        {login ? <p className="pw-login-error">{loginErrors}</p> : null}

        {login ? (
          <p className="pw-login-container--terms pw-login-terms">
            By clicking “Log In” below, you agree to our
            <a href={"/tos"}> Terms of Service</a> and{" "}
            <a href={"/privacy"}>Privacy Policy.</a>
          </p>
        ) : (
          <p className="pw-login-container--terms">
            By choosing to sign up, I acknowledge that I accept PINCHme's{" "}
            <a href={"/tos"}>Terms of Service</a> and{" "}
            <a href={"/privacy"}>Privacy Policy.</a>
          </p>
        )}

        <Button
          className={classNames({ "pw-login-btn": login })}
          onClick={event => handleFormSubmit(event)}
          minWidth="214"
          label={login ? "Log In" : "I WANT FREE SAMPLES"}
          type="outline"
        />
      </form>

      {login ? (
        <p className="pw-login-container--already-member pw-confirm-mail">
          <a href={"confirmation"}>Didn't get a confirmation email?</a>
        </p>
      ) : (
        <p className="pw-login-container--restrictions">
          PINCHme only ships to the 48 contiguous states in America but not to
          Hawaii, Alaska, Puerto Rico, the U.S. Virgin Islands, Guam, Canada or
          internationally.
        </p>
      )}

      {login ? (
        <p className="pw-login-container--already-member pw-not-member">
          Not a member?
          <span onClick={() => setLogin(false)}>Sign Up Now</span>
        </p>
      ) : (
        <p className="pw-login-container--already-member">
          Already a member?
          <span onClick={() => setLogin(true)}>Log in</span>
        </p>
      )}
    </div>
  );
}

export default SignupForm;

SignupForm.propTypes = {
  closeable: PropTypes.bool
};
